import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState({ next: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const inp = "w-full border-b border-border bg-transparent py-3 text-sm focus:outline-none focus:border-primary";

  const submit = async (e) => {
    e.preventDefault();
    if (pw.next.length < 8) { toast.error("كلمة المرور 8 أحرف على الأقل"); return; }
    if (pw.next !== pw.confirm) { toast.error("كلمتا المرور غير متطابقتين"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw.next });
      setDone(true);
      toast.success("تم تعيين كلمة المرور بنجاح");
      setTimeout(() => nav("/login"), 1500);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-background fade-in">
      <div className="w-full max-w-sm">
        <img src="/logo.png" alt="RNF_Line" className="h-20 w-auto mx-auto mb-3" />
        <h1 className="text-center font-display text-2xl mb-1">تعيين كلمة مرور جديدة</h1>
        {!token ? (
          <p className="text-center text-destructive text-sm mt-6" data-testid="reset-invalid">الرابط غير صالح — يرجى طلب رابط استعادة جديد من صفحة الدخول.</p>
        ) : done ? (
          <p className="text-center text-text-muted text-sm mt-6" data-testid="reset-done">تم تحديث كلمة المرور. يتم تحويلك لتسجيل الدخول…</p>
        ) : (
          <>
            <p className="text-center text-text-muted text-xs mb-8">أدخلي كلمة مرور جديدة لحسابك.</p>
            <form onSubmit={submit} className="space-y-4">
              <input type="password" value={pw.next} onChange={(e) => setPw({ ...pw, next: e.target.value })} required
                placeholder="كلمة المرور الجديدة" data-testid="reset-new-password" dir="ltr" className={inp} />
              <input type="password" value={pw.confirm} onChange={(e) => setPw({ ...pw, confirm: e.target.value })} required
                placeholder="تأكيد كلمة المرور" data-testid="reset-confirm-password" dir="ltr" className={inp} />
              <button type="submit" disabled={loading} data-testid="reset-submit-btn" className="btn-primary w-full py-3.5 text-sm mt-4">
                {loading ? "…" : "حفظ كلمة المرور"}
              </button>
            </form>
          </>
        )}
        <button onClick={() => nav("/login")} data-testid="reset-to-login" className="w-full text-center text-xs text-text-muted mt-6 hover:text-primary">العودة لتسجيل الدخول</button>
      </div>
    </div>
  );
}
